import {
    faHouseUser,
    faKey,
    faMoneyBillAlt,
    faSearchDollar,
    faTools,
    faUniversity,
    faUsers,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useParams } from "react-router-dom";

import { ACESSOS } from "../../Routes/Acessos";

import "./styles.css";

const modulosAds = [
    {
        idModulo: ACESSOS.COBRANCA.ID_MODULO,
        icon: faSearchDollar,
        color: "--Cobranca",
        title: "Cobrança",
        subtitle:
            "Diminua a inadimplência da sua empresa com um sistema de gestão de cobrança. Acompanhe em tempo real os dados de inadimplência da sua carteira e melhore a porcentagem de recuperação da sua equipe. ",
        itemsA: [
            "Gestão de acordos de negociação",
            "Fila de cobrança",
            "Automação de divisão de carteira",
            "Régua de cobrança",
            "Negativação SPC e Serasa",
            "Integração com discadores e telefonia",
            "Gestão completa de tickets de atendimento",
        ],
        itemsB: [
            "E-mails integrados dentro do CRM",
            "WhatsApp integrado dentro do CRM (Múltiplos operadores por número)",
            "Geração de documentos personalizados  (Termos de Renegociação)",
            "Histórico completo de interações dos usuários",
            "Relatórios inteligentes BI",
        ],
    },
    {
        idModulo: ACESSOS.ATENDIMENTO.ID_MODULO,
        icon: faUsers,
        color: "--AtendimentoCliente",
        title: "Atendimento Ao Cliente",
        subtitle:
            "Controle de todas as etapas do atendimento prestado ao seu cliente. Da sua solicitação a sua conclusão",
        itemsA: ["", "", "", "", "", ""],
        itemsB: ["", "", "", "", "", ""],
    },
    {
        idModulo: ACESSOS.ASSISTENCIA.ID_MODULO,
        icon: faTools,
        color: "--AssistenciaTecnica",
        title: "Assistência Técnica",
        subtitle:
            "Controle todas as etapas do atendimento técnico prestado ao seu cliente. Da solicitação a conclusão.",
        itemsA: [
            "Gestão completa de tickets de atendimento",
            "Controle de atendimentos por patologia",
            "Gestão de disponibilidade de agenda dos técnicos",
            "Agendamento de vistoria integrado ao cliente",
            "Pesquisa de satisfação e conformidade do serviço",
        ],
        itemsB: [
            "Gestão de garantias por patologia",
            "Aplicativo offline para gestão das ordens de serviço e apontamentos",
            "Gestão de prazos por categoria de atendimentos",
            "Emails integrados ao CRM",
            "Histórico completo de interações dos usuários",
            "Relatórios inteligentes BI",
        ],
    },
    {
        idModulo: ACESSOS.VENDAS.ID_MODULO,
        icon: faMoneyBillAlt,
        color: "--Vendas",
        title: "Vendas",
        subtitle:
            "Organize seu pipeline de vendas, controle seus leads e prospects, mensure a conversão por diversos canais de atendimento e gerencie a produtividade da sua equipe de vendas. ",
        itemsA: [
            "Funil de vendas personalizado",
            "Automação de marketing",
            "Gestão de Leads",
            "Integração com plataformas como Facebook e RD Station",
            "Perfil do Lead ",
            "Gestão de Imobiliárias e Corretores",
            "Tabela de preços",
        ],
        itemsB: [
            "Espelho de vendas",
            "Mapa de Implantação",
            "Gestão de propostas",
            "Análise de Crédito (SICAQ/Integração Correspondentes)",
            "Gestão de Contratos ",
            "Integração DocuSign",
            "Gestão de Comissões",
            "Relatórios Inteligentes BI",
        ],
    },
    {
        idModulo: ACESSOS.REPASSE.ID_MODULO,
        icon: faUniversity,
        color: "--Repasse",
        title: "Repasse",
        subtitle:
            "Controle e agilize o processo de crédito imobiliário e reduza o número de inconformidades no dossiê.",
        itemsA: [
            "Funil de Repasse personalizado e flexível (Crédito Associativo e SFH)",
            "Gestão de Prazos por Etapa do Funil",
            "Checklists de documentação por etapas",
            "Gestão da produtividade dos operadores/correspondentes",
            "Gestão de Análise de Crédito (SICAQ)",
        ],
        itemsB: [
            "Pasta digital do cliente",
            "Geração de aditivos",
            "Assinatura digital (DocuSign)",
            "Controle de diferença de financiamento",
            "Histórico completo de interações dos operadores e rastreabilidade ",
            "Relatórios inteligentes BI (prazo médio por etapa, liberação de recursos...)",
        ],
    },
    {
        idModulo: ACESSOS.ENTREGA_DE_CHAVES.ID_MODULO,
        icon: faKey,
        color: "--EntregaChaves",
        title: "Vistoria e Entrega de Chaves",
        subtitle:
            "Controle e acompanhe visualmente as fases de entrega das unidades e áreas comuns do empreendimento. Aplique formulários configurados para as inspeções finais com o cliente, assegurando a resolução de pendências de fases anteriores da obra.",
        itemsA: [
            "Processo formal de entrega e recebimento",
            "Agendamentos individuais e em lotes das unidades",
            "Realização de inspeções e reinspeções",
            "Credibilidade com o cliente",
            "Painel de vistoria e entrega",
            "Integração com os processos e qualidade da assistência técnica",
        ],
        itemsB: [
            "Gestão completa dos tickets de atendimento",
            "Gestão de disponibilidade de agendas",
            "Agendamento de vistoria integrado ao cliente",
            "Pesquisa pós ocupacional",
            "Histórico completo de interações dos usuários",
            "Relatórios inteligentes BI",
        ],
    },
    {
        idModulo: 7,
        icon: faHouseUser,
        color: "--PosOcupacional",
        title: "PortalAdmin",
        subtitle: "",
        itemsA: [],
        itemsB: [],
    },
];

export default function ModuloADS() {
    const idModulo = Number.parseInt(
        useParams<{ idModulo: string }>().idModulo
    );
    const moduloObj = modulosAds.find((m) => m.idModulo === idModulo);

    const backgroundColor = `var(${moduloObj?.color ?? "--capys"})`;

    return (
        <div
            className={`modulo-Ad-container text-break`}
            key={idModulo}
            style={{ backgroundColor }}
        >
            <div
                className={
                    "d-flex flex-column no-gutters justify-content-center align-items-center"
                }
            >
                <h1>
                    {moduloObj?.title}
                    {moduloObj?.icon && (
                        <FontAwesomeIcon
                            className="ml-5"
                            icon={moduloObj.icon}
                        />
                    )}
                </h1>
                <p> {moduloObj?.subtitle} </p>
                <div className="mt-5 d-flex align-items-center justify-content-between row">
                    <div className="col-12 col-lg-6">
                        <ul>
                            {moduloObj?.itemsA.map((item) => (
                                <li key={item}>{item}</li>
                            ))}
                        </ul>
                    </div>
                    <div className="col-12 col-lg-6">
                        <ul>
                            {moduloObj?.itemsB.map((item) => (
                                <li key={item}>{item}</li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
}
